module.exports = __webpack_public_path__ + "img/tramites.c45bc281.png";